import React, { useState, useEffect } from 'react';
import {
  AddGuestContainer,
  AddGuestLabel,
  AddGuestButton,
  SearchContainer,
  SearchInput,
  DropdownList,
  DropdownItem,
  NoResults,
  SelectedGuestsContainer,
  GuestItem,
  RemoveButton,
  ErrorMessage,
} from '../styles';
import { getUsers } from '../api';

const AddGuestComponent = ({ invitedUsers, onUsernamesChange }) => {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [selectedGuests, setSelectedGuests] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await getUsers();
        
        if (!response.ok) {
          throw new Error('Falha ao buscar dados da API');
        }
    
        const data = await response.json();
        setUsers(data); 
    
        if (data.length === 0) {
          setError('Nenhum usuário encontrado.');
        }
    
      } catch (error) {
        setError('Erro ao buscar usuários: ' + error.message);
        console.error('Erro ao buscar usuários:', error);
      }
    };

    fetchUsers();
  }, []);

  const filteredUsers = users.filter((user) =>
    user.fullName.toLowerCase().includes(search.toLowerCase()) ||
    user.username.toLowerCase().includes(search.toLowerCase())
  );

  const handleAddGuest = () => {
    setShowSearch(true); // Exibe o campo de busca quando o botão "Adicionar Convidado" for clicado
  };

  const handleAddGuestToList = (user) => {
    setSelectedGuests((prev) => [...prev, { fullName: user.fullName, username: user.username }]);
    setSearch('');
    setShowSearch(false); // Esconde o campo de busca após a adição
    onUsernamesChange([...invitedUsers, user.username]);
  };

  const handleRemoveGuest = (userToRemove) => {
    setSelectedGuests((prev) => prev.filter((user) => user.username !== userToRemove.username));
    onUsernamesChange(invitedUsers.filter((username) => username !== userToRemove.username));
  };

  return (
    <AddGuestContainer>
      <AddGuestLabel>Convidado:</AddGuestLabel>

      {showSearch && (
        <SearchContainer>
          <SearchInput
            type="text"
            placeholder="Buscar usuário"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {search && (
            <DropdownList>
              {filteredUsers.map((user) => (
                <DropdownItem
                  key={user.username}
                  onClick={() => handleAddGuestToList(user)}
                >
                  {user.fullName} ({user.username})  {/* Aqui exibe o fullName e o username */}
                </DropdownItem>
              ))}
              {filteredUsers.length === 0 && <NoResults>Nenhum usuário encontrado</NoResults>}
            </DropdownList>
          )}
        </SearchContainer>
      )}

      <SelectedGuestsContainer>
        {selectedGuests.map((guest) => (
          <GuestItem key={guest.username}>
            <span>{guest.nome} ({guest.username})</span>
            <RemoveButton onClick={() => handleRemoveGuest(guest)}>-</RemoveButton>
          </GuestItem>
        ))}
      </SelectedGuestsContainer>
      <AddGuestButton onClick={handleAddGuest}>Adicionar Convidado</AddGuestButton>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </AddGuestContainer>
  );
};

export default AddGuestComponent;
